import React from 'react';
import PropTypes from 'prop-types';
import {action, computed, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';

import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';
import {RadioGroup} from 'spa/Components/Form';
import Button from 'spa/Components/Button';

import './edit-basket-item.less';

@withRouter
@inject(({
  store: {
    notifications,
    tracker,
  },
}) => (
  {
    notifications,
    tracker,
  }
))
@observer
@withI18n
class EditBasketItem extends React.Component {
  static propTypes = {
    itemInfo: PropTypes.shape({
      duration_id: PropTypes.number,
      durationPickerTitle: PropTypes.string,
      specialityDurations: PropTypes.object,
      specialityName: PropTypes.string,
    }).isRequired,
    onClickRemove: PropTypes.func.isRequired,
    onEditOption: PropTypes.func.isRequired,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
  }

  UNSAFE_componentWillMount() {
    const {itemInfo} = this.props;

    this.selectedOption = itemInfo && itemInfo.duration_id;
  }

  @observable selectedOption;

  /*
   * User edits the option for the selected treatment
   */
  @autobind
  @action('onEditOption - EditBasketItem')
  onEditOption(event) {
    const {itemInfo, tracker} = this.props;

    const selectedOption = event && event.target && event.target.value;

    this.selectedOption = parseInt(selectedOption, 10);

    tracker.track('Changed option in basket edit item screen', {
      duration_id: this.selectedOption,
      category: 'Basket',
      label: itemInfo.specialityName,
    });
  }

  /*
   * User clicks the button to save changes
   */
  @autobind
  @action('onClickSave - EditBasketItem')
  onClickSave(event) {
    const {itemInfo, onEditOption, tracker} = this.props;

    tracker.track('Clicked save changes on basket edit item screen', {
      duration_id: this.selectedOption,
      category: 'Basket',
      label: itemInfo.specialityName,
    });

    onEditOption(this.selectedOption);
  }

  @computed get treatmentOptions() {
    const {i18n} = this.context;
    const {itemInfo} = this.props;

    if (!itemInfo) return null;

    const {specialityDurations = []} = itemInfo;

    return specialityDurations.map(duration => ({
      extraLabel: duration.isRecommendedOption ? i18n._x('Recommended for selected treatment', 'Booking flow') : '',
      isRecommendedOption: duration.isRecommendedOption,
      label: duration.name,
      value: duration.id,
    }));
  }

  render() {
    const {i18n} = this.context;
    const {
      itemInfo,
      onClickRemove,
    } = this.props;
    const {
      onClickSave,
      onEditOption,
      selectedOption,
      treatmentOptions,
    } = this;

    return (
      <div className="edit-basket-item">
        <h1 className="edit-basket-item__title">
          {itemInfo.specialityName}
        </h1>
        <div className="edit-basket-item__block-radio">
          <h3 className="edit-basket-item__options-title">
            {itemInfo.durationPickerTitle}
          </h3>
          <RadioGroup
            className="edit-basket-item__radio-group"
            hasBottomBorder
            isBlockOptions
            isRightRadio
            items={treatmentOptions}
            name="treatment-options-selector"
            onChange={onEditOption}
            selected={selectedOption}
            value={selectedOption}
          />
        </div>
        <div className="edit-basket-item__fixed-control">
          <Button
            caps={false}
            className="button button--block button--extra-rounded button--normal basket__add-treatment-button"
            data-qa="basket-remove-item-button"
            label={i18n._x('Remove from basket', 'Basket selection')}
            onClick={onClickRemove}
            theme="quaternary"
          />
          <Button
            caps={false}
            className="button button--block button--extra-rounded button--normal basket__proceed-button"
            label={i18n._x('Save changes', 'Basket selection')}
            onClick={onClickSave}
            theme="primary"
          />
        </div>
      </div>
    );
  }
}

export default EditBasketItem;



// WEBPACK FOOTER //
// ./spa/Pages/Booking/Basket/EditBasketItem.jsx